(function () {
  function fmt(t) { // "17:00" -> "5pm"
    var p = t.split(':'); var h = parseInt(p[0], 10); var m = p[1];
    var ap = h >= 12 ? 'pm' : 'am'; var hh = h % 12 || 12;
    return m === '00' ? hh + ap : hh + ':' + m + ap;
  }
  function computeHours(el) {
    var rows; try { rows = JSON.parse(el.getAttribute('data-hours') || '[]'); } catch (e) { rows = []; }
    var dot = el.querySelector('[data-or-status-dot]'); var txt = el.querySelector('[data-or-status-text]');
    if (!rows.length || !dot || !txt) return;
    var now = new Date(); var day = now.getDay(); var nowMin = now.getHours() * 60 + now.getMinutes();
    var today = rows.filter(function (r) { return String(r.day) === String(day) && r.open && r.close; })[0];
    var open = false, until = '';
    if (today) {
      var o = today.open.split(':'), c = today.close.split(':');
      var om = (+o[0]) * 60 + (+o[1]), cm = (+c[0]) * 60 + (+c[1]);
      if (nowMin >= om && nowMin < cm) { open = true; until = fmt(today.close); }
    }
    if (open) { dot.removeAttribute('data-closed'); txt.textContent = (el.dataset.openText || 'Open now · until [until]').replace('[until]', until); }
    else { dot.setAttribute('data-closed', ''); txt.textContent = (el.dataset.closedText || 'Closed'); }
  }
  function init() {
    document.querySelectorAll('[data-or-sticky]').forEach(function (el) {
      // dismissed this session?
      var id = el.id;
      try { if (sessionStorage.getItem('or-sticky-dismissed:' + id) === '1') { el.remove(); return; } } catch (e) {}
      computeHours(el);
      var trigger = parseInt(el.getAttribute('data-scroll-trigger') || '0', 10);
      function reveal() {
        var doc = document.documentElement;
        var scrolled = (window.scrollY || doc.scrollTop);
        var max = (doc.scrollHeight - window.innerHeight) || 1;
        if (trigger <= 0 || (scrolled / max) * 100 >= trigger) {
          el.hidden = false;
          window.removeEventListener('scroll', reveal);
        }
      }
      reveal();
      if (el.hidden) window.addEventListener('scroll', reveal, { passive: true });
      var close = el.querySelector('[data-or-sticky-close]');
      if (close) close.addEventListener('click', function () {
        el.hidden = true;
        try { sessionStorage.setItem('or-sticky-dismissed:' + id, '1'); } catch (e) {}
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
